import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoogleLoginDirective } from './google-login.directive';
import { GoogleService } from './google.service';
import { MemberLoadingGoogleComponent } from './member-loading-google/member-loading-google.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    GoogleLoginDirective,
    MemberLoadingGoogleComponent,
  ],
  exports: [
    GoogleLoginDirective
  ],
})
export class GoogleMemberModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: GoogleMemberModule,
      providers: [GoogleService]
    };
  }
}
